import { TabStyles } from '@tableau/widgets';
import * as TypeStyle from 'typestyle';

const Colors = TabStyles.Colors!;

export const DataGridColors = {
  Selected: '#cde7f8',
  // Hover: Colors.F3,
  AltRow: Colors.F2,

  HeaderBorder: Colors.L5,
  HorizontalGridLine: Colors.L2_5,
  SelectedGridLine: 'white',
  VerticalGridLine: Colors.L4,
};

export const FocusIndicatorStyleName: string = TypeStyle.style({
  $nest: {
    '& [role="gridcell"]:focus, & [role="columnheader"]:focus': {
      outline: 'none',
    },
    '&.focus-visible [role="gridcell"]:focus, &.focus-visible [role="columnheader"]:focus': {
      boxShadow: `inset 0 0 0 1px ${Colors.Focus}`,
    }
  }
});
